define([
  'react',
  'underscore',
  'JSON',
  'immutable',
  'lib/sumome/sumolist/formsync',
  'es6!sumo/util',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/form',
  'es6!launcher/util/listbuilder/wysiwyg/dom',
  'es6!launcher/util/listbuilder/constants',
  'es6!launcher/util/listbuilder/embedded/util',
  'es6!launcher/util/listbuilder/stylebuffer/welcomemat',
], (React, _, JSON, Immutable, FormSync, Util, ListBuilderForm, WysiwygDom, Constants, EmbeddedUtil, WelcomeMatStyleBuffer) => {
  const APP_ID = '156085c5-0017-4150-b225-a731ad248f38';
  const { FEATURES } = Util.Constants;

  const getAnchorOffset = (element, offset = 0) => {
    if (!element || !element.parentNode) return window.innerHeight;

    if (element.parentNode === document.body || element.parentNode === document.documentElement) {
      return offset || element.offsetTop;
    }

    if (offset === 0) {
      return getAnchorOffset(element.parentNode, element.offsetTop);
    }

    const style = window.getComputedStyle(element);
    return getAnchorOffset(element.parentNode, ['absolute', 'relative'].indexOf(style.getPropertyValue('position')) > -1 ? offset + element.offsetTop : offset);
  };

  const scrollTo = function scrollTo(to, duration, callback) {
    let scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
    if (scrollTop === to) return callback();
    const diff = to - scrollTop;
    const scrollStep = (Math.PI * 10) / duration;
    const start = scrollTop;
    let count = 0;
    let timeout;
    let scrollInterval = setInterval(() => {
      scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      if (Math.abs(scrollTop - to) > 1) {
        count += 1;
        const currPos = start + diff * (Math.round((0.5 - 0.5 * Math.cos(count * scrollStep)) * 100) / 100);
        window.scrollTo(0, currPos);
      } else {
        clearInterval(scrollInterval);
        if (timeout) clearTimeout(timeout);
        scrollInterval = null;
        callback();
      }
    }, 10);

    timeout = setTimeout(() => {
      clearInterval(scrollInterval);
      return callback();
    }, duration * 1.05);
  };

  class WelcomeMatPopup extends ListBuilderForm {
    constructor(service, settings) {
      super(service, settings);

      this.isClickEmitted = false;
      this.isFormSubmitted = false;
      this.anchorPosition = 0;
      this.isFooter = false;
      this.isMobile = Util.isMobile();
      this.lastWidth = window.innerWidth;

      this.onChangeForm = this.onChangeForm.bind(this);
      this.onResize = _.debounce(this.onResize.bind(this), 250);

      this.onClickPoweredByVariant = this.onClickPoweredByVariant.bind(this);

      this.responsiveFormat = window.innerWidth > window.innerHeight ? 'default' : 'mobile';

      this.removeModal = this.removeModal.bind(this);
      this.close = this.close.bind(this);
    }

    onClickPoweredByVariant() {
      const powerVariant = 'd003d67a-722b-4c0f-8318-a446bde19b75';
      const refLink = `https://sumome.com/?src=sm-lb-${this.service.api.properties.siteId}`;
      const event = `powered-by-click:${APP_ID}:${powerVariant}`;

      this.service.api.emit('event', { 'appId': '2d1fffc9-378f-4b61-ac79-2dc8a077b827', 'event': event });
      window.open(refLink);
    }

    close = () => {
      // Apply original transition and padding-top styles
      document.body.style.transition = document.body.dataset.sumoOriginalTransition;
      document.body.style.paddingTop = document.body.dataset.sumoOriginalPaddingTop;
      document.body.style.position = document.body.dataset.sumoOriginalPosition;
      document.body.style.overflowX = document.body.dataset.sumoOriginalOverflowX;

      // Set scroll top to top of the page
      if (this.settings.get('display_mode') === 'normal') {
        window.scrollTo(0, 0);
      }

      this.removeModal();

      WelcomeMatStyleBuffer.removeStyleBuffer();
      this.service.onClose();
    }

    animateClose() {
      const displayMode = this.settings.get('display_mode');

      const duration = 1000;
      const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      const offsetTop = this.popupEl.offsetTop;
      const offsetHeight = this.popupEl.offsetHeight;
      const scrollHeight = this.popupEl.scrollHeight;

      this.service.removeEvents();

      // Remove landing page class on body if it was added
      if (this.settings.get('is_landing_page')) {
        document.documentElement.className = document.documentElement.className.replace(/(sumome\-welcome\-mat\-landing\-page)/g, '');
        document.body.className = document.body.className.replace(/(sumome\-welcome\-mat\-landing\-page)/g, '');
      }

      switch(displayMode) {
        case 'normal':
          scrollTo(window.innerHeight, duration, this.close);
          break;
        case 'embedded':
          if (scrollTop < offsetTop || this.isFooter || offsetTop + (window.innerHeight * 2) > Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)) {
            // Scroll above mat
            scrollTo(offsetTop - window.innerHeight, duration, this.close);
          } else {
            // Scroll below mat
            scrollTo(offsetTop + window.innerHeight, duration, this.close);
          }
          break;
        case 'parallax':
          scrollTo((scrollHeight - offsetHeight) / this.service.parallaxScrollMultiplier, duration, this.close);
          break;
      }
    }

    onResize() {
      if (this.isMobile) {
        if (this.lastWidth === window.innerWidth) {
          // Don't resize
          return false;
        }

        this.lastWidth = window.innerWidth;
      }

      if (this.isFooter) {
        // Embedded Footer: Keep mat at the bottom
        this.popupEl.style.top = '-100%';
        this.popupEl.style.top = `${Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)}px`;
      } else if (this.settings.get('display_mode') === 'embedded') {
        // Embedded: Recalculate anchor position
        const anchorEl = document.querySelector('.sumome-welcomemat-anchor') || EmbeddedUtil.findEmbeddedAnchor(50, true);
        this.anchorPosition = getAnchorOffset(anchorEl);
        this.popupEl.style.top = `${this.anchorPosition - 2}px`;
      } else if (this.settings.get('display_mode') === 'normal') {
        // Normal: Readjust body padding-top
        const paddingTop = parseInt(document.body.dataset.sumomeOriginalComputedPaddingTop);
        document.body.style.paddingTop = `${window.innerHeight + paddingTop}px`;
      } else {
        // Parallax: Find new anchor and correct styles on contentEl
        const anchorEl = document.querySelector('.sumome-welcomemat-anchor') || EmbeddedUtil.findEmbeddedAnchor(50, true);
        this.anchorPosition = getAnchorOffset(anchorEl);
        this.contentEl.style.top = `${this.anchorPosition}px`;
        this.contentEl.style.height = `${window.innerHeight}px`;
        this.contentEl.style.marginBottom = `${window.innerHeight}px`;
      }

      // Adjust responsive format
      if (this.responsiveFormat === 'default' && window.innerWidth < window.innerHeight) {
        this.responsiveFormat = 'mobile';
        this.contentEl.className = this.contentEl.className.replace('sumome-wysiwyg-responsive-format-default', 'sumome-wysiwyg-responsive-format-mobile');
      } else if (this.responsiveFormat === 'mobile' && window.innerWidth > window.innerHeight) {
        this.responsiveFormat = 'default';
        this.contentEl.className = this.contentEl.className.replace('sumome-wysiwyg-responsive-format-mobile', 'sumome-wysiwyg-responsive-format-default');
      }
    }

    show() {
      const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
      const displayMode = this.settings.get('display_mode');
      const trackingPixels = this.settings.get('pixels_shown');

      // Set shown cookie (if not embedded/parallax)
      if (displayMode === 'normal') {
        setTimeout(() => this.service.setShownCookie(this));
        this.service.api.emit('setProperties', { 'yield': true });
      } else {
        setTimeout(() => this.service.setEmbeddedShownCookie(this));
      }

      this.logEvent('popup');

      if (['embedded', 'parallax'].indexOf(displayMode) > -1) {
        // Embedded/Parallax setup
        const anchorEl = document.querySelector('.sumome-welcomemat-anchor') || EmbeddedUtil.findEmbeddedAnchor(50, true);
        this.anchorPosition = getAnchorOffset(anchorEl);
        displayMode === 'embedded' ? this.installEmbedded() : this.installParallax();
      } else {
        // Normal welcome mat
        this.install();
        WelcomeMatStyleBuffer.styleBufferTop(this.popupEl);
      }

      this.contentEl.className += ` sumome-wysiwyg-responsive-format-${this.responsiveFormat}`;

      if (trackingPixels && hasTrackingPixels) {
        this.addTrackingPixels(trackingPixels, null, { id: 'tracking' });
      }
    }

    install() {
      // container
      this.popupEl = document.createElement('div');
      this.popupEl.className = 'sumo-form-wrapper welcome-mat-popup';

      // content
      this.contentEl = document.createElement('div');
      this.contentEl.className = 'welcome-mat-popup-content';
      this.popupEl.appendChild(this.contentEl);

      document.body.insertBefore(this.popupEl, document.body.childNodes[0]);
      this.showStep(this.currentStep || 'subscribe');

      setTimeout(() => {
        this.contentEl.style.top = 0;
        // TODO: Move to a styleBuffer file. It will need to be more complex than this.
        const bodyStyle = window.getComputedStyle(document.body);
        const paddingTop = bodyStyle.getPropertyValue('padding-top').indexOf('px') > -1 ? parseInt(bodyStyle.getPropertyValue('padding-top')) : 0;

        // Scroll to top of the page
        window.scrollTo(0, 0);

        // Store original paddingTop and transition (inline)
        document.body.dataset.sumomeOriginalComputedPaddingTop = paddingTop;
        document.body.dataset.sumoOriginalPaddingTop = document.body.style.paddingTop;
        document.body.dataset.sumoOriginalTransition = document.body.style.transition;
        document.body.dataset.sumoOriginalPosition = document.body.style.position;
        document.body.dataset.sumoOriginalOverflowX = document.body.style.overflowX;

        // Apply new styles to body
        document.body.style.transition = `${bodyStyle.getPropertyValue('transition') || ''}, padding-top 1s ease-in-out`;
        document.body.style.paddingTop = `${window.innerHeight + paddingTop}px`;
        document.body.style.position = 'static';
        document.body.style.overflowX = 'hidden';

        // Remove body transition after showing. It's not needed again until animateClose.
        setTimeout(() => {
          document.body.style.transition = document.body.dataset.sumoOriginalTransition;
        }, 1000);

        if (this.settings.get('is_landing_page')) {
          // Disable scroll
          document.documentElement.className += ' sumome-welcome-mat-landing-page';
          document.body.className += ' sumome-welcome-mat-landing-page';
        }
      });
    }

    installEmbedded() {
      // container
      this.popupEl = document.createElement('div');
      this.popupEl.className = 'sumo-form-wrapper welcome-mat-popup welcome-mat-embedded-popup';
      const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

      if (scrollHeight <= window.innerHeight * 2) {
        // Put mat at bottom of page
        this.popupEl.style.top = `${scrollHeight}px`;
        this.isFooter = true;
      } else {
        this.popupEl.style.top = `${this.anchorPosition - 2}px`;
      }

      // content
      this.contentEl = document.createElement('div');
      this.contentEl.className = 'welcome-mat-popup-content';
      this.popupEl.appendChild(this.contentEl);

      document.body.insertBefore(this.popupEl, document.body.childNodes[0]);
      this.showStep(this.currentStep || 'subscribe');
    }

    installParallax() {
      // container
      this.popupEl = document.createElement('div');
      this.popupEl.className = 'sumo-form-wrapper welcome-mat-popup welcome-mat-parallax-popup';

      // content
      this.contentEl = document.createElement('div');
      this.contentEl.className = 'welcome-mat-popup-content';
      this.contentEl.style.top = `${this.anchorPosition}px`;
      this.contentEl.style.height = `${window.innerHeight}px`;
      this.contentEl.style.marginBottom = `${window.innerHeight}px`;
      this.popupEl.appendChild(this.contentEl);

      // shim
      this.shimEl = document.createElement('div');
      this.shimEl.className = 'welcome-mat-popup-shim';
      this.shimEl.style.top = `${this.anchorPosition + window.innerHeight}px`;
      this.shimEl.style.height = `${window.innerHeight}px`;
      this.popupEl.appendChild(this.shimEl);

      document.body.insertBefore(this.popupEl, document.body.childNodes[0]);
      this.showStep(this.currentStep || 'subscribe');
    }
  }

  return WelcomeMatPopup;
});
